<template>
  <div id="app">
    <!-- <div class="text-left py-3 px-3">
      <a @click="backDashboard()" href="#" class="main-color-text"><i class="fas fa-chevron-left"></i> Painel</a>
    </div> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Index",
  methods: {
    backDashboard(){
      var app = JSON.parse(localStorage.application);
      var url = 'https://' + app.app_panel + '/dashboard';
      window.location.href = url;
    }
  },
  mounted() {

  },
};
</script>

<style lang="scss">
@import "./assets/css/style.scss";

:root {
  --main-color: #222222;
}
</style>
